module.exports = __webpack_public_path__ + "img/code-laptop.e7789472.jpg";